"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _inputTime = require("./inputTime.style");
var _components = require("../../components");
var _dateTime = require("../../utils/dateTime");
var _DatePickerFooter = _interopRequireDefault(require("../../components/shared/DatePickerFooter"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const InputTime = /*#__PURE__*/(0, _react.forwardRef)((_a, ref) => {
  var {
      className = 'inputTime',
      children,
      disabled,
      fit = 'medium',
      footerType,
      error,
      errorMessage,
      hint,
      label,
      placeholder,
      popperProps,
      prefix,
      icon = 'clock',
      iconPosition = 'right',
      id,
      maxHour = 24,
      maxMins = 60,
      minHour = 0,
      minMins = 0,
      name,
      readOnly = false,
      required,
      showOptional,
      suffix,
      tooltipDescription,
      width,
      value,
      variant = 'default',
      autocomplete = 'off',
      onChange,
      onSave,
      onBlur,
      onFocus
    } = _a,
    rest = __rest(_a, ["className", "children", "disabled", "fit", "footerType", "error", "errorMessage", "hint", "label", "placeholder", "popperProps", "prefix", "icon", "iconPosition", "id", "maxHour", "maxMins", "minHour", "minMins", "name", "readOnly", "required", "showOptional", "suffix", "tooltipDescription", "width", "value", "variant", "autocomplete", "onChange", "onSave", "onBlur", "onFocus"]);
  const mainDivref = (0, _react.useRef)(null);
  const [startDate, setStartDate] = (0, _react.useState)();
  const textInput = (0, _react.useRef)(null);
  const [selectedHour, setSelectedHour] = (0, _react.useState)(startDate ? (0, _dateTime.getHour)(startDate || new Date()) : 0);
  const [selectedMin, setSelectedMin] = (0, _react.useState)((0, _dateTime.getMinute)(startDate || new Date()));
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [activeScroll, setActiveScroll] = (0, _react.useState)(false);
  const minsListRef = (0, _react.useRef)(null);
  const hourListRef = (0, _react.useRef)(null);
  // TODO: Kept for reference, will remove in furture
  // useEffect(() => {
  //   if (defaultHour !== undefined || defaultMins !== undefined) {
  //     setStartDate(
  //       setHours(setMinutes(new Date(), defaultMins || 0), defaultHour || 0)
  //     );
  //   }
  //   defaultHour && setSelectedHour(defaultHour);
  //   defaultMins && setSelectedMin(defaultMins);
  // }, [defaultHour, defaultMins]);
  (0, _react.useEffect)(() => {
    if (value) {
      if (typeof value === 'string') {
        const formatedDate = (0, _dateTime.getFormattedLongDateTime)(value, 'HH:mm');
        setStartDate(formatedDate);
        setSelectedHour((0, _dateTime.getHour)(formatedDate));
        setSelectedMin((0, _dateTime.getMinute)(formatedDate));
      } else {
        setStartDate(value);
        setSelectedHour((0, _dateTime.getHour)(value));
        setSelectedMin((0, _dateTime.getMinute)(value));
      }
    }
  }, [value]);
  const onTimeClicked = (e, type) => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    const input = e.target;
    let defaultHour = 0;
    let defaultMins = 0;
    let date;
    setActiveScroll(false);
    if (type === 'defaultHour') {
      defaultHour = Number(input.innerText);
      setSelectedHour(defaultHour);
      if (startDate) {
        date = (0, _dateTime.setTime)(startDate, defaultHour, null);
      } else {
        date = (0, _dateTime.setHours)((0, _dateTime.setMinutes)(new Date(), defaultMins), defaultHour);
        setStartDate(date);
      }
    } else {
      defaultMins = Number(input.innerText);
      setSelectedMin(defaultMins);
      if (startDate) {
        date = (0, _dateTime.setTime)(startDate, null, defaultMins);
      } else {
        date = (0, _dateTime.setHours)((0, _dateTime.setMinutes)(new Date(), defaultMins), defaultHour);
        setStartDate(date);
      }
      setIsOpen(false);
    }
    handleChange(date);
  };
  const handleOnClickOutside = () => {
    setIsOpen(false);
  };
  const handleChange = date => {
    setSelectedHour((0, _dateTime.getHour)(date));
    setSelectedMin((0, _dateTime.getMinute)(date));
    setStartDate(date);
    onChange(date, (0, _dateTime.getHour)(date), (0, _dateTime.getMinute)(date));
  };
  const onClockIconClick = e => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    setIsOpen(!isOpen);
    if (textInput && textInput.current) {
      textInput.current.setFocus(true);
    }
  };
  const handleCancel = () => {
    if (selectedHour !== undefined || selectedMin !== undefined) {
      (0, _dateTime.setHours)((0, _dateTime.setMinutes)(new Date(), selectedMin || 0), selectedHour || 0);
    }
    setIsOpen(false);
  };
  const handleReset = () => {
    if ((selectedMin !== null || selectedHour !== null) && onSave) {
      onSave(null);
    }
    setStartDate(null);
  };
  const handleSave = () => {
    if (onSave && startDate) {
      onSave(startDate);
    }
  };
  const handleOnFocus = e => {
    setIsOpen(true);
    if (onFocus) {
      onFocus(e);
    }
  };
  const handleKeyDown = event => {
    if (event.key === 'Escape') {
      setIsOpen(false);
    }
  };
  const isDisabled = (index, type) => {
    if (typeof type.max != 'undefined' && typeof type.min != 'undefined') {
      return index > type.max - 1 || index < type.min;
    } else if (typeof type.max != 'undefined') {
      return index > type.max;
    } else if (typeof type.min != 'undefined') {
      return index < type.min;
    }
    return false;
  };
  const isActive = (index, type) => {
    if (index === type.selectedType && !activeScroll && !isDisabled(index, {
      max: type.max,
      min: type.min
    })) {
      return 'time active';
    }
    return 'time';
  };
  const CustomTimePopover = () => (0, _jsxRuntime.jsxs)(_inputTime.Components.CustomTimeInput, {
    children: [(0, _jsxRuntime.jsx)(_inputTime.Components.TimeList, (0, _extends2["default"])({
      ref: hourListRef,
      onScroll: () => setActiveScroll(true)
    }, {
      children: (0, _dateTime.allHours)().map((item, index) => (0, _jsxRuntime.jsx)(_components.Button, {
        className: isActive(index, {
          max: maxHour,
          min: minHour,
          selectedType: selectedHour || 0
        }),
        label: item,
        disabled: isDisabled(index, {
          max: maxHour,
          min: minHour
        }),
        variant: index === selectedHour ? 'filled' : 'outlined',
        fit: "medium",
        onClick: e => {
          onTimeClicked(e, 'defaultHour');
        }
      }, index))
    })), (0, _jsxRuntime.jsx)(_inputTime.Components.TimeList, (0, _extends2["default"])({
      ref: minsListRef
    }, {
      children: (0, _dateTime.allMins)().map((item, index) => (0, _jsxRuntime.jsx)(_components.Button, {
        className: isActive(index, {
          max: maxMins,
          min: minMins,
          selectedType: selectedMin || 0
        }),
        label: item,
        variant: index === selectedMin ? 'filled' : 'outlined',
        disabled: isDisabled(index, {
          max: maxMins,
          min: minMins
        }),
        fit: "medium",
        onClick: e => onTimeClicked(e, 'defaultMins')
      }, index))
    }))]
  });
  const renderCustomInput = (0, _jsxRuntime.jsx)(_components.Input, (0, _extends2["default"])({
    className: className,
    disabled: disabled,
    error: error,
    errorMessage: errorMessage,
    fit: fit,
    hint: hint,
    icon: icon,
    iconPosition: iconPosition,
    id: id,
    label: label,
    name: name,
    placeholder: placeholder,
    prefix: prefix,
    required: required,
    readOnly: readOnly,
    showOptional: showOptional,
    suffix: suffix,
    tooltipDescription: tooltipDescription,
    value: (startDate === null || startDate === void 0 ? void 0 : startDate.toString()) || '',
    variant: variant,
    width: width
  }, rest, {
    onIconClick: e => onClockIconClick(e)
  }));
  return (0, _jsxRuntime.jsx)(_inputTime.Components.RefWrapper, (0, _extends2["default"])({
    className: className,
    ref: ref
  }, {
    children: (0, _jsxRuntime.jsx)(_inputTime.Components.Wrapper, (0, _extends2["default"])({
      ref: mainDivref,
      error: error,
      fit: fit,
      width: width,
      variant: variant,
      "data-testid": "time-picker"
    }, {
      children: (0, _jsxRuntime.jsx)(_inputTime.Components.InputWrapper, (0, _extends2["default"])({
        error: error,
        fit: fit,
        width: width,
        variant: variant
      }, {
        children: (0, _jsxRuntime.jsx)(_reactDatepicker["default"], (0, _extends2["default"])({
          id: id,
          ref: textInput,
          required: required,
          customInput: renderCustomInput,
          customTimeInput: (0, _jsxRuntime.jsx)(CustomTimePopover, {}),
          dateFormat: "HH:mm",
          disabled: disabled,
          name: name,
          open: isOpen && !readOnly,
          placeholderText: placeholder || 'HH:mm',
          popperProps: popperProps,
          readOnly: readOnly,
          selected: startDate,
          minTime: (0, _dateTime.setHours)((0, _dateTime.setMinutes)(new Date(), minMins), minHour),
          maxTime: (0, _dateTime.setHours)((0, _dateTime.setMinutes)(new Date(), maxMins), maxHour),
          showTimeInput: true,
          showTimeSelectOnly: true,
          autoComplete: autocomplete,
          onChange: date => handleChange(date),
          onFocus: handleOnFocus,
          onBlur: onBlur,
          onKeyDown: handleKeyDown,
          onClickOutside: () => handleOnClickOutside()
        }, {
          children: footerType && (0, _jsxRuntime.jsx)(_DatePickerFooter["default"], {
            footerType: footerType,
            customFooter: children,
            onCancel: handleCancel,
            onReset: handleReset,
            onSave: handleSave
          })
        }))
      }))
    }))
  }));
});
var _default = exports["default"] = InputTime;